import { Controller } from "@hotwired/stimulus"

// CSV export modal for list screens. A dropdown item (data-export-type / data-export-url)
// opens a <dialog> with a Cally <calendar-range> + period presets; CSVダウンロード builds
// `url?export_type=&fromDate=&toDate=` and navigates to it, which the controller's
// send_data action streams back as a file download. Mirrors the reference csv-export-modal.
export default class extends Controller {
  static targets = ["modal", "title", "calendar", "rangeLabel"]

  connect() {
    // Default range: last 30 days (inclusive).
    this.to = this.today()
    this.from = this.addDays(this.to, -29)
    this.exportType = "account_info"
    this.exportUrl = ""
  }

  // Dropdown item -> open the dialog for the chosen export type.
  openModal(e) {
    const ds = e.currentTarget.dataset
    this.exportType = ds.exportType || "account_info"
    this.exportUrl = ds.exportUrl || ""
    if (this.hasTitleTarget && ds.exportLabel) {
      this.titleTarget.textContent = `${ds.exportLabel} CSVエクスポート`
    }
    this.syncCalendar()
    this.updateRangeLabel()
    if (this.hasModalTarget) this.modalTarget.showModal()
  }

  closeModal() {
    if (this.hasModalTarget) this.modalTarget.close()
  }

  // Period preset buttons inside the modal.
  selectPreset(e) {
    const preset = e.currentTarget.dataset.preset
    const now = this.today()
    let from = now
    let to = now
    switch (preset) {
      case "last7days":  from = this.addDays(now, -6); break
      case "last30days": from = this.addDays(now, -29); break
      case "thisMonth":
        from = new Date(now.getFullYear(), now.getMonth(), 1)
        to = new Date(now.getFullYear(), now.getMonth() + 1, 0)
        break
      case "lastMonth":
        from = new Date(now.getFullYear(), now.getMonth() - 1, 1)
        to = new Date(now.getFullYear(), now.getMonth(), 0)
        break
      default: return
    }
    this.from = this.format(from)
    this.to = this.format(to)
    this.syncCalendar()
    this.updateRangeLabel()
  }

  onCalendarChange(e) {
    const value = (e.target && e.target.value) || ""
    const [from, to] = value.split("/")
    if (from) this.from = from
    if (to) this.to = to
    else if (from) this.to = from
    this.updateRangeLabel()
  }

  // Build the export URL and navigate -> server streams the CSV as a download.
  download() {
    if (!this.exportUrl) return
    const params = new URLSearchParams()
    params.set("export_type", this.exportType)
    params.set("fromDate", this.from)
    params.set("toDate", this.to)
    window.location.assign(`${this.exportUrl}?${params.toString()}`)
    this.closeModal()
  }

  // ---- helpers ----
  syncCalendar() {
    if (this.hasCalendarTarget) {
      this.calendarTarget.value = `${this.from}/${this.to}`
      if ("focusedDate" in this.calendarTarget) this.calendarTarget.focusedDate = this.from
    }
  }

  updateRangeLabel() {
    if (!this.hasRangeLabelTarget) return
    this.rangeLabelTarget.textContent = `${this.toLabel(this.from)} - ${this.toLabel(this.to)}`
  }

  today() {
    const d = new Date()
    return new Date(d.getFullYear(), d.getMonth(), d.getDate())
  }
  addDays(date, n) { const d = new Date(date); d.setDate(d.getDate() + n); return this.format(d) }
  format(date) {
    if (typeof date === "string") return date
    const y = date.getFullYear()
    const m = String(date.getMonth() + 1).padStart(2, "0")
    const d = String(date.getDate()).padStart(2, "0")
    return `${y}-${m}-${d}`
  }
  toLabel(str) { return String(str).replace(/-/g, "/") }
}
